import { Component, inject } from '@angular/core';
import { SupplierSapBankTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SupplierSapBankTypeCreateDto,
  SupplierSapBankTypeDto,
  SupplierSapBankTypeExcelDownloadDto,
  SupplierSapBankTypeUpdateDto,
} from '../proxy/controlling/dtos/supplier-sap-bank-type';
import { SUPPLIERSAPBANKTYPE_CONFIG, SUPPLIERSAPBANKTYPE_FIELDS } from './supplier-sap-bank-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-supplier-sap-bank-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SupplierSapBankTypeService, ConfirmationService],
  templateUrl: './supplier-sap-bank-type.html',
  styleUrl: './supplier-sap-bank-type.scss',
})
export class SupplierSapBankType extends BaseCrudComponent<
  SupplierSapBankTypeDto,
  SupplierSapBankTypeCreateDto,
  SupplierSapBankTypeUpdateDto,
  SupplierSapBankTypeExcelDownloadDto
> {
  service = inject(SupplierSapBankTypeService);
  config = SUPPLIERSAPBANKTYPE_CONFIG;
  fields = SUPPLIERSAPBANKTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: SupplierSapBankTypeDto): SupplierSapBankTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SupplierSapBankType';
  }
}
